import TWIADateUtil from "./aspects/_TWIADateUtil";
import TWIAValidationFunctions from "./aspects/_TWIAValidationFunctions";

const validationFunctions = {
    TWIADateUtil,
    TWIAValidationFunctions
}

export default validationFunctions;